function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 会議素材状態情報　モデル
 */
var SessionMaterialStateInstanceModel =
/**
 * コンストラクタ
 *
 */
function SessionMaterialStateInstanceModel() {
  _classCallCheck(this, SessionMaterialStateInstanceModel);

  this.File = undefined;
  this.Progress = 0;
  this.LoadedSize = 0;
  this.TotalSize = 0;
  this.Done = false;
  this.Error = false;
  this.Cancel = false;
  this.JqXHR = undefined;
};

export { SessionMaterialStateInstanceModel as default };